import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, TypeEnum } from '@wlp/ui-bs-account-payment-favorite';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsMyDataService } from '@wlp/ui-bs-my-data';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import {
  PopoverFavoritesComponent,
} from 'src/app/views/themes/sentinel/modals/popover-favorites/popover-favorites.component';

import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';

@Component({
  selector: 'app-favorites-charging',
  templateUrl: './favorites-charging.page.html',
  styleUrls: ['./favorites-charging.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class FavoritesChargingPage implements OnInit {

  private userProfile: UserInfoProfile;
  private favorite: any;
  public backgroundHeader: any;
  public switchFavorites: string = 'favorites';
  public favoriteId: any;
  public listFavoritesShow: any;
  public listFavorites: any;
  public isUp: boolean = false;
  public formFavorite: FormGroup;
  public errorMessages: any;
  public selectedFavorite: boolean = false;
  public ownership: boolean = false;
  public listUf: Array<any>;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;


  constructor(
    protected userInfoService: UserInfoService,
    private layoutConfigService: LayoutConfigService,
    public favoriteService: AccountPaymentFavoriteService,
    private myDataService: UiBsMyDataService,
    private navCtrl: NavController,
    private cdr: ChangeDetectorRef,
    private loadingService: LoadingService,
    public pipeFilter: FavoritesDataFilterPipe,
    public popoverController: PopoverController,
    private modalController: ModalController,
    private translate: UiBsTranslateService,

  ) { }

  ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.backgroundHeader = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.loadUser();
    this.listUf = this.favoriteService.getUf();
    this.formFavorite = this.favoriteService.createFormFavoriteCharging();
    this.errorMessages = this.favoriteService.getFormMessageError();
  }

  private loadUser() {
    this.userInfoService.getInfoProfile().then(
      (res) => {
        // console.log('UserProfile', res);

        this.userProfile = res;
        if (this.userProfile) {
          this.getFavorites();
        }
      }
    );
  }

  private getFavorites() {
    this.loadingService.show();
    this.favoriteService
      .getAllFavoritesType(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, TypeEnum.BILLET)
      .pipe(
        tap((data) => {
          this.loadingService.hide();
          // console.log('getFavorites', data);

          this.listFavoritesShow = this.favoriteService.sortFavoritesListByName(data);
        }),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
    this.loadingService.hide();
    this.cdr.detectChanges();
  }

  public goBack() {
    this.navCtrl.navigateRoot(['app/dashboard']);
  }

  public segmentChanged(favorite: string) {
    if (favorite == 'favorites') this.getFavorites();
    this.switchFavorites = favorite;
  }

  public sortList() {
    this.isUp = !this.isUp;
    this.listFavoritesShow = this.listFavoritesShow.reverse();
  }

  public filterFavorites(value: string) {
    if (value !== '') {
      this.listFavoritesShow = this.pipeFilter.transform(this.listFavorites, value);
    } else {
      this.getFavorites();
    }
  }

  public async editOrDelete(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverFavoritesComponent,
      cssClass: 'popover-class',
      event: ev.event,
      translucent: true,
      mode: 'md',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 'exclude') {
        this.deleteFavorite(ev.favorite);
      }
      if (data.data == "edit") {
        this.editFavorite(ev.favorite);
      }
    });
    return await popover.present();
  }

  private deleteFavorite(favorite: any) {
    this.loadingService.show();
    this.favoriteService.deleteFavorite(favorite).pipe(
      tap((data) => {
        if (data.status) {
          this.resetForm();
          this.getFavorites();
          this.statusNotification('success', 'FAVORITES.MESSAGES.DELETE_SUCCESS', true);
          this.favoriteId = undefined;
          this.switchFavorites = 'favorites';
        } else {
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        }
        this.loadingService.hide();
      }),
      catchError((_) => {
        this.loadingService.hide();
        return null;
      }),
    ).subscribe();
  }

  public editFavorite(favorite: any) {
    this.favoriteId = favorite.id;
    this.favorite = favorite;
    // console.log('edit favorite', favorite);

    this.formFavorite.setValue({
      name: favorite.name,
      document: favorite.document,
      email: favorite.email,
      postalCode: favorite.zipCode,
      address: favorite.address,
      numberAddress: favorite.addressNumber,
      complementAddress: favorite.addressComplement,
      neighborhood: favorite.neighborhood,
      cityAddress: favorite.city,
      uf: favorite.state,
      country: favorite.country
    });

    this.selectedFavorite = true;
    this.switchFavorites = 'new';
    // console.log('edit favorite', this.formFavorite);
  }

  public sameOwnership() {
    if (this.ownership === false) {
      this.ownership = true;
      this.myDataService.getPersonalData(this.userProfile.uuidAccount).subscribe(
        (res) => {
          this.formFavorite.controls.document.setValue(this.formatCnpjCpf(res.document));
          this.formFavorite.controls.name.setValue(res.name);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.formFavorite.controls.document.setValue('');
      this.formFavorite.controls.name.setValue('');
      this.ownership = false;
      this.cdr.detectChanges();
    }
  }

  private formatCnpjCpf(value: string) {
    const document = value.replace(/\D/g, '');
    if (document.length === 11) {
      return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (document.length > 11) {
      return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else {
      return value;
    }
  }

  public searchPostalCode(data: any) {
    this.favoriteService.searchPostaCode(data.target.value);
  }

  public resetForm() {
    this.formFavorite = this.favoriteService.createFormFavoriteCharging();
    this.favoriteId = null;
    this.switchFavorites = 'favorites';
    this.selectedFavorite = false;
  }

  public continue() {
    if (!!this.favoriteId && !!this.favorite.uuid) {
      this.favorite = {
        id: this.favoriteId,
        uuid: this.favorite.uuid,
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        name: this.formFavorite.controls.name.value,
        document: this.formFavorite.controls.document.value,
        email: this.formFavorite.controls.email.value,
        zipCode: this.formFavorite.controls.postalCode.value,
        address: this.formFavorite.controls.address.value,
        addressNumber: this.formFavorite.controls.numberAddress.value,
        addressComplement: this.formFavorite.controls.complementAddress.value,
        neighborhood: this.formFavorite.controls.neighborhood.value,
        city: this.formFavorite.controls.cityAddress.value,
        state: this.formFavorite.controls.uf.value,
        country: this.formFavorite.controls.country.value,
        type: TypeEnum.BILLET
      };
      this.updateFavorite(this.favorite);
    } else {
      let prepare: AccountPaymentFavoriteDTO = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        name: this.formFavorite.controls.name.value,
        document: this.formFavorite.controls.document.value,
        email: this.formFavorite.controls.email.value,
        zipCode: this.formFavorite.controls.postalCode.value,
        address: this.formFavorite.controls.address.value,
        addressNumber: this.formFavorite.controls.numberAddress.value,
        addressComplement: this.formFavorite.controls.complementAddress.value,
        neighborhood: this.formFavorite.controls.neighborhood.value,
        city: this.formFavorite.controls.cityAddress.value,
        state: this.formFavorite.controls.uf.value,
        country: this.formFavorite.controls.country.value,
        type: TypeEnum.BILLET
      };
      this.saveFavorite(prepare);
    }
  }

  private updateFavorite(favoriteBody: any) {
    this.loadingService.show();
    this.favoriteService.updateFavorite(favoriteBody).pipe(
      tap((data) => {
        if (data.status) {
          this.statusNotification('success', 'FAVORITES.MESSAGES.UPDATE_SUCCESS', true);
          this.getFavorites();
          this.resetForm();
          this.favoriteId = undefined;
          this.switchFavorites = "favorites";
        } else {
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        }
        this.loadingService.hide();
      }),
      catchError((_) => {
        this.loadingService.hide();
        this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        return of(null);
      }),
    ).subscribe();
  }

  private saveFavorite(favoriteBody: any) {
    this.favoriteService.saveFavorite(favoriteBody).pipe(
      tap((data) => {
        if (data.status) {
          this.statusNotification('success', 'FAVORITES.MESSAGES.SAVE_SUCCESS', true);
          this.resetForm();
          this.getFavorites();
          this.favoriteId = undefined;
          this.switchFavorites = 'favorites'
        } else {
          this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        }
        this.loadingService.hide();
      }),
      catchError((_) => {
        this.loadingService.hide();
        this.statusNotification('warning-circle', 'FAVORITES.MESSAGES.FAILED', true);
        return of(null);
      }),
    ).subscribe();
  }

  private async statusNotification(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'FAVORITES.BUTTONS.CLOSE',
        translate: translate,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  ngOnDestroy() {
    this.resetForm();
  }
}
